/* eslint-disable no-void */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-children-prop */
import { Tooltip } from "@material-ui/core";
import React, { ReactNode } from "react";

interface IButtonProps {
  children: ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | undefined;
  color?: string | undefined;
  bg?: string | undefined;
  text?: string | undefined;
  onClick?: any;
  style?: React.CSSProperties;
  className?: string
}

const TT = ({
  children,
  text,
  size,
  onClick,
  bg,
  color,
  style,
  className
}: {
  children: ReactNode;
  text: string | undefined;
  size: number;
  onClick: any;
  bg: string | undefined;
  color: string | undefined;
  style: React.CSSProperties | undefined;
  className: string | undefined;
}) => {
  let _style = {};
  let _bg = "#00000000";
  let _color = "#000";

  if (bg) _bg = bg;
  if (color) _color = color; 
  if (style) _style = style;

  if (text) {
    return (
      <Tooltip title={text}>
        <button
          type="button"
          onClick={onClick}
          style={{

            height: size,
            width: size,
            minWidth: "fit-content",
            minHeight: 'max-content',
            background: _bg,
            color: _color,
            cursor: "pointer",
            borderRadius: 4,
            border: 0,
            ..._style,
          }}
        >
          {children}
        </button>
      </Tooltip>
    );
  }
  return (
    <button
      className={className}
      type="button"
      onClick={onClick}
      style={{
        height: size,
        width: size,
        minWidth: "fit-content",
        minHeight: "fit-content",
        border: 0,
        borderRadius: 4,
        background: _bg,
        color: _color,
        cursor: "pointer",
        ..._style,
      }}
    >
      {children}
    </button>
  );
};
function RcButton({children, size, text, onClick, color, bg, style, className }: IButtonProps) {
  let _size = 24;
  if (size === "xs") _size = 12;
  if (size === "sm") _size = 16;
  if (size === "md") _size = 24;
  if (size === "lg") _size = 30;
  if (size === "xl") _size = 36;
  if (size === "xxl")_size = 45;
  return (
    <>
      <TT 
        children={children} 
        text={text} 
        size={_size} 
        onClick={onClick} 
        color={color} 
        bg={bg} 
        style={style}
        className={className}
      />
    </>
  );
}


RcButton.defaultProps = {
  size: "md",
  text: "",
  color: 'black',
  bg: "transparent",
  style: {},
  onClick: () => void 0,
  className: ""
};

export default RcButton;
